import React, { useEffect, useState } from "react";
import Cabecalho from "../componentes/Cabecalho";
import Rodape from "../componentes/Rodape";
import { fetchRevenda } from "../utils/firestoreUtils";
import { id_firebase } from "../content-site";
import { scrollToTop } from '../utils/scrollUtils';

export default function VideosPage() {
    const [revenda, setRevenda] = useState({});
    const totalVideos = 67;

    const videos = Array.from({ length: totalVideos }, (_, i) => ({
        id: i + 1,
        title: `Feedback ${i + 1}`,
        url: `/videos/${String(i + 1).padStart(2, "0")}.mp4`,
    }));

    const [page, setPage] = useState(1);
    const videosPerPage = 12;

    const displayedVideos = videos.slice(0, page * videosPerPage);

    useEffect(() => {
        scrollToTop();
        fetchRevenda(id_firebase, (state) => {
            if (state && state.revenda) {
                setRevenda(state.revenda);
            }
        });
    }, []);

    return (
        <div>
            <Cabecalho revenda={revenda} />
            <div className="videos-page-container">
                <h1 className="videos-title">Galeria de Vídeos</h1>

                <div className="videos-grid">
                    {displayedVideos.map((video) => (
                        <div key={video.id} className="video-card">
                            <video className="video-player" controls preload="metadata">
                                <source src={video.url} type="video/mp4" />
                                Seu navegador não suporta vídeos.
                            </video>

                            <div className="video-card-body">
                                <h2 className="video-card-title">{video.title}</h2>
                            </div>
                        </div>
                    ))}
                </div>

                {displayedVideos.length < videos.length && (
                    <button onClick={() => setPage(page + 1)} className="videos-load-more">
                        Carregar mais
                    </button>
                )}
            </div>
            <Rodape revenda={revenda} />
        </div>
    );
}
